import script from "./ImportProfileTransferHttp.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImportProfileTransferHttp.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__